import React from "react";
import { Box, styled } from "@mui/material";
import ContactText from "./contactText/ContactText";
import ContactForm from "./contactForm/ContactForm";

const MainBox = styled(Box)(({theme}) => ({
  width: "100%",
  display: "flex",
  flexDirection: 'row',
  justifyContent: "space-evenly",
  alignItems: "center",
  padding: theme.spacing(4, 0),
  gap: 0,
  backgroundColor: '#fff',

  //mobile screen
  [theme.breakpoints.down('mdlg')]: {
    flexDirection: 'column',
    height: "auto",
    gap: theme.spacing(10),
  }
}))

function Contact() {
  return (
    <>
      <MainBox>
        <ContactText/>
        <ContactForm />
      </MainBox>
    </>
  );
}

export default Contact;
